import React from "react";

function inputField({ type, name, autocomplete, id, placeholder }) {
    return (
        <div>
            <input
                className="w-full m-2 md:m-0 duration-500 text-black dark:text-gray-300 ease-in-out bg-transparent no-underline border-blue-600 focus:border-dashed outline-none border-2 p-3  rounded-md  hover:border-blue-600 active:border-blue-600"
                type={type}
                name={name}
                autoComplete={autocomplete}
                id={id}
                placeholder={placeholder}
            />
        </div>
    );
}

export default inputField;
